<template>
  <div>
    <div class="line_loading"><i class="fas fa-spinner fa-spin"></i></div>
  </div>
</template>

<script>
import { LINE_TOP_REGISTRATION } from '@/store/line/actions'

export default {
  name: 'LineTopRegist',
  data () {
    return {
      params: null
    }
  },
  methods: {
    getQueryStrings () {
      try {
        const search = document.location.search.substring(1)
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        this.params = params
      } catch (e) {
      }

      this.topRegist()
    },
    topRegist () {
      this.$store.dispatch(LINE_TOP_REGISTRATION, this.params)
        .then((data) => {
          location.href = data.url
        })
        .catch((error) => {
          if (error.errorStatus === 400) {
            location.href = error.errorData.url
          }
        })
    }
  },
  created () {
    this.getQueryStrings()
  }
}
</script>
